module.exports = __webpack_public_path__ + "img/1539316889.4637d64f.jpg";